import {map} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import {SEARCH_SUCCESS} from '../search/search.action';
import * as FavouritesActions from '../favourite/favourite.action';

import * as HistoryActions from './history.action';

//maps
export const mapSearchToAddHistoryActions = action$ =>
  action$.pipe(ofType(SEARCH_SUCCESS), map(action => HistoryActions.historyAdded(action.payload.query)));

//to sync the history with favourite
export const mapToUpdateHistoryActions = (action$, state$) =>
  action$.pipe(
    ofType(
      HistoryActions.HISTORY_ADDED,
      FavouritesActions.FAVOURITE_ADD_SUCCESS,
      FavouritesActions.FAVOURITE_UPDATE_SUCCESS,
      FavouritesActions.FAVOURITE_REMOVE_SUCCESS,
      FavouritesActions.FAVOURITE_RESTORE_SUCCESS
    ),
    map(() => HistoryActions.historyUpdated(state$.value.favourites.list))
  );
